import React from 'react';
import { useTranslation } from 'react-i18next';
import dl_img from '../../../assest/Home/Decentral_new1x.png';
import zkp_img from '../../../assest/Home/Zkp_new1x.png';
import biometric_img from '../../../assest/Home/biometrics_new1x.png';
import passwd_img from '../../../assest/Home/Passless_new1x.png';
import './face-scan-two.styles.scss';

export const FaceScanTwo = () => {
  const { t } = useTranslation();

  return (
    <div className='faceScan-content xx-ripple'>
      <p className='faceScan-content_title'>{t('faceScanTwo.title')}</p>
      <p className='faceScan-content_desc'>{t('faceScanTwo.description')}</p>
      <p className='faceScan-content_feat'>{t('faceScanTwo.techLabel')}</p>

      <div className='faceScan-content-img'>
        <div className='faceScan-link-block'>
          <div>
            <button className='btn-animate'>
              <a href='/platform/biometrics'>
                <img src={biometric_img} alt='Biometrics' className='icon-face-content' />
              </a>
            </button>
          </div>
          <p className='icon-face-title'>{t('faceScanTwo.items.biometrics')}</p>
        </div>

        <div className='faceScan-link-block'>
          <div>
            <button className='btn-animate'>
              <a href='/platform/distributed-ledger'>
                <img src={dl_img} alt='Distributed Ledger' className='icon-face-content' />
              </a>
            </button>
          </div>
          <p className='icon-face-title'>{t('faceScanTwo.items.ledger')}</p>
        </div>

        <div className='faceScan-link-block'>
          <div>
            <button className='btn-animate'>
              <a href='/solution/passwordless'>
                <img src={passwd_img} alt='Passwordless' className='icon-face-content' />
              </a>
            </button>
          </div>
          <p className='icon-face-title'>{t('faceScanTwo.items.passwordless')}</p>
        </div>

        <div className='faceScan-link-block'>
          <div>
            <button className='btn-animate'>
              <a href='/platform/zero-knowledge-proof'>
                <img src={zkp_img} alt='Zero-Knowledge Proof' className='icon-face-content' />
              </a>
            </button>
          </div>
          <p className='icon-face-title'>{t('faceScanTwo.items.zkp')}</p>
        </div>
      </div>
    </div>
  );
};
